import MoveImage from "assets/move-image.png";

const Handler = () => {
  return <img src={MoveImage} alt="Move" className="cursor-move" />;
};

export default Handler;
